<template lang="pug">
  footer.l-footer
    | Copyright {{year}} (株) 佐藤物産
</template>

<script>
export default {
  name: 'Footer',
  props: [],
  data() {
    return {
      year: 2017,
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  },
};
</script>



// WEBPACK FOOTER //
// footer.vue?436539bd